// Translation: Account > Members > Members list > Removal dialog (English)
export default Object.freeze({
	actions: {
		cancel: 'Cancel',
		remove: 'Remove'
	},
	message: {
		text: 'Are you sure to remove this team member?',
		title: 'Member will be removed'
	}
})
